import React from "react";
import { View, StyleSheet, Image } from "@react-pdf/renderer";
import stylesReport from "./styles";
import sebastian from "../../assets/sebastian.png";
import yamila from "../../assets/firmaYamila.png";
import natalia from "../../assets/natalia.png";
import ruth from "../../assets/ruth.png";
import amiloidosis from "../../assets/amiloidosis.png";
import acgh from "../../assets/acgh.png";
import exoma from "../../assets/exoma.png";
import pdm from "../../assets/pdm.png";

const FirmaEspecialista = ({
  isSigned = true,
  nombreEspecialista,
  styleFromParent,
  bigInform = false,
}) => {
  const { showSign, showSignSmall, notShowSign } = stylesReport;

  const getAssetPicture = (nombre) => {
    if (nombre === "sebastian") {
      return sebastian;
    } else if (nombre === "yamila") {
      return yamila;
    } else if (nombre === "natalia") {
      return natalia;
    } else if (nombre === "ruth") {
      return ruth;
    } else if (nombre === "amiloidosis") {
      return amiloidosis;
    } else if (nombre === "acgh") {
      return acgh;
    } else if (nombre === "exoma") {
      return exoma;
    } else if (nombre === "pdm") {
      return pdm;
    }
  };

  return (
    <View style={styleFromParent}>
      <Image
        src={getAssetPicture(nombreEspecialista)}
        style={isSigned ? (bigInform ? showSignSmall : showSign) : notShowSign}
      />
    </View>
  );
};

export default FirmaEspecialista;
